import { useBlockUserMutation } from "../../../../../../../api/mutations/useBlockUserMutation";
import { useUnblockUserMutation } from "../../../../../../../api/mutations/useUnblockUserMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../../../utilities/api";
import { phoneUtil } from "../../../../../../../utilities/phone";

const MSG = {
  forbidden: "Action not allowed",
  phone_number_not_match: "Phone number does not match",
  cannot_block_tech_user: "You cannot block a technical user",
  __fallbackBlock: "An error occurred while blocking the user. Try again later",
  __fallbackUnblock:
    "An error occurred while unblocking the user. Try again later",
  blocked: "User blocked successfully",
  unblocked: "User unblocked successfully",
};

export const useBlockHandler = (userId) => {
  const block = useBlockUserMutation({
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(MSG[message] || MSG.__fallbackBlock);
    },
    onSuccess: () => {
      uiNotification.success(MSG.blocked);
    },
  });

  const unblock = useUnblockUserMutation({
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(MSG[message] || MSG.__fallbackUnblock);
    },
    onSuccess: () => {
      uiNotification.success(MSG.unblocked);
    },
  });

  return {
    block: (phone) => {
      return block.mutateAsync({
        id: userId,
        phone: phoneUtil.compose(phone),
      });
    },
    unblock: () => {
      return unblock.mutateAsync({
        id: userId,
      });
    },
    isLoading: block.isLoading || unblock.isLoading,
  };
};
